const userTrumpet = {
  // 小号列表
  getList: `/userApi/v1/UserTrumpet/getList`,
  // 添加小号功能
  add: `/userApi/v1/UserTrumpet/add`,
  // 编辑小号名称
  editName: `/userApi/v1/UserTrumpet/editName`
};

export default userTrumpet;
